import { Component, OnInit } from '@angular/core';
import { ClientServiceService } from '../client-service/client-service.service';
import {PackageServiceService} from '../../package/service/package-service.service';
import {PatientService} from '../../patient/service/patient.service';
import {Router} from '@angular/router';

@Component({
  selector: 'app-client-view',
  templateUrl: './client-view.component.html',
  styleUrls: ['./client-view.component.css']
})
export class ClientViewComponent implements OnInit {
    itemsPerPage = 10;
    currentPage = 1;
    noOfClients: any;
    regExp = '';
    constructor(private clientService: ClientServiceService, private router: Router) { }
    public clientList: any = [];
    public loading = true;
    ngOnInit() {
        this.getAllClients();
    }
    pageChanged(event) {
        this.currentPage = event;
        this.getAllClients();
        console.log(event);
    }
    public getAllClients() {
        this.loading = true;
        this.clientService.getAllClients(this.currentPage - 1, '', this.itemsPerPage, this.regExp)
            .subscribe(data => {
                const response: any = data.json();
                this.clientList = response.clients;
                this.noOfClients = response.numberOfClients;
                console.log(response.clients);

                this.loading = false;
                // TODO - Uncomment below code when using actual API
                // const response: any = data;
                // if (response.status === 200) {
                //   this.userList = response.result;
                // } else {
                //   this.toastr.error('', 'Please try again');
                // }
            }, (error) => {
                this.loading = false;
                // this.toastr.error('', 'Please try again');
            });
    }
    public addOrder(clientId) {
        this.router.navigate( [ '/elasticcare/add/order' ], { fragment: clientId } );
    }
    public addTeam(clientId) {
        this.router.navigate( [ '/elasticcare/add/client/team' ], { fragment: clientId } );
    }
    public viewTeam(clientId) {
        this.router.navigate( [ '/elasticcare/clientcontacts' ], { fragment: clientId } );
    }
    public viewCampaigns(clientId, clientName) {
        this.router.navigate( [ '/elasticcare/campaign' , {clientIdParam: clientId, clientNameParam: clientName}]);
    }
    public viewClientInventory(clientId) {
        this.router.navigate( [ '/elasticcare/clientinventory' , {clientIdParam: clientId}]);
    }

    search() {
        console.log('' + this.regExp);
        this.getAllClients();
    }
}
